import { db } from "./DBHelper";
import { STORAGE_KEYS, COLLECTIONS } from "const";
import TableService from "services/TableService";
import ShopsHelper from "./ShopsHelper";

const AREAS_TABLES_CACHE_DURATION_IN_MS = 10 * 60 * 1000;

export const saveAreas = (areas) => db.addAll(COLLECTIONS.AREAS.name, areas);
export const saveTables = (tables) => db.addAll(COLLECTIONS.TABLES.name, tables);

export const getAreasFromDB = () => db.getAll(COLLECTIONS.AREAS.name);
export const getTablesFromDB = () => db.getAll(COLLECTIONS.TABLES.name);
export const getTableById = (id) => db.get(COLLECTIONS.TABLES.name, id);

export async function loadInitialAreasAndTables(syncFromBE = false) {
  const shopProfile = ShopsHelper.getCachedShopProfile();
  const isPremium = ShopsHelper.isPremiumShop(shopProfile);

  if (!isPremium) {
    return {
      areas: [],
      tables: [],
      fromCache: true,
    };
  }

  const now = Date.now();
  const lastSyncedAt = Number(localStorage.getItem(STORAGE_KEYS.LAST_TABLE_AREA_FETCH_TIME));

  const cacheExpired = !lastSyncedAt || now - lastSyncedAt > AREAS_TABLES_CACHE_DURATION_IN_MS;

  if (!cacheExpired && !syncFromBE) {
    const cachedAreas = await getAreasFromDB();
    const cachedTables = await getTablesFromDB();

    if (cachedAreas.length && cachedTables.length) {
      return {
        areas: cachedAreas,
        tables: cachedTables,
        fromCache: true,
      };
    }
  }

  try {
    const [areasResponse, tablesResponse] = await Promise.all([TableService.getAreas(), TableService.getTables()]);

    const rawAreas = Array.isArray(areasResponse) ? areasResponse : areasResponse?.results || [];
    const rawTables = Array.isArray(tablesResponse) ? tablesResponse : tablesResponse?.results || [];

    await saveAreas(rawAreas);
    await saveTables(rawTables);

    localStorage.setItem(STORAGE_KEYS.LAST_TABLE_AREA_FETCH_TIME, String(now));

    return {
      areas: rawAreas,
      tables: rawTables,
      fromCache: false,
    };
  } catch (error) {
    console.warn("Area/Table API failed, falling back to IndexedDB");

    const cachedAreas = await getAreasFromDB();
    const cachedTables = await getTablesFromDB();

    if (cachedAreas.length && cachedTables.length) {
      return {
        areas: cachedAreas,
        tables: cachedTables,
        fromCache: true,
      };
    }

    throw new Error("No areas/tables available from API or cache");
  }
}
